import { useContext, useState } from 'react';

import { useUserProfile } from '@atom/hooks/useUserProfile';
import { Button, TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ViewRequestContext from '../ViewRequestContext';

import ReceiverStatus from './ReceiverStatus';

import classes from './ardotView.module.css';

const styles = {
  rejectButton: {
    width: '48%',
    border: `1px solid ${colors.neutral.ash}`,
  },
  approveButton: {
    width: '48%',
  },
  label: {
    color: colors.neutral.dim,
  },
  cancelButton: {
    marginRight: '1rem',
  },
};

const ReceiverSection = () => {
  const userProfile = useUserProfile();
  const { activeRequest, setStatus, setConfirmOpen, comments, setComments } =
    useContext(ViewRequestContext);
  const [rejectView, setRejectView] = useState<boolean>(false);

  const approveClick = () => {
    setStatus(AssetRequestStatus.APPROVED);
    setConfirmOpen(true);
  };

  const rejectClick = () => {
    setStatus(AssetRequestStatus.REJECTED);
    setConfirmOpen(true);
  };

  const resetForm = () => {
    setRejectView(false);
    setComments(null);
  };

  const reviewer = `${activeRequest?.receiver?.firstName} ${activeRequest?.receiver?.lastName}`;

  const showApproveReject =
    !rejectView &&
    (userProfile?.userId === activeRequest?.receiver?.id ||
      hasRolePermissions(ROLE_SETS.ORG_ADMIN)) &&
    activeRequest?.status === AssetRequestStatus.PENDING_APPROVAL;
  const showComments =
    !isNilOrEmpty(activeRequest?.comments) &&
    !isNilOrEmpty(activeRequest?.receiveDate);

  return (
    <div className={classes.approvalContainer}>
      <div className={classes.stepTitle}>Step 2: Receiver Approval</div>
      <div>
        <div className={classes.rowTitle}>Receiver</div>
        <div>{reviewer}</div>
      </div>
      {showComments && (
        <div>
          <div className={classes.rowTitle}>Comments</div>
          <div>{activeRequest?.comments}</div>
        </div>
      )}
      <ReceiverStatus />
      {rejectView && (
        <>
          <div className={classes.inputRow}>
            <TextField
              slotProps={{ inputLabel: { style: styles.label } }}
              fullWidth
              value={comments}
              label="Comments (optional)"
              onChange={event => setComments(event.target.value)}
            />
          </div>
          <div className={classes.approveButtons}>
            <Button sx={styles.cancelButton} onClick={resetForm}>
              Cancel
            </Button>
            <Button color="error" variant="contained" onClick={rejectClick}>
              Reject
            </Button>
          </div>
        </>
      )}
      {showApproveReject && (
        <div className={classes.subButtons}>
          <Button
            style={styles.rejectButton}
            onClick={() => setRejectView(true)}
          >
            Reject
          </Button>
          <Button
            style={styles.approveButton}
            color="primary"
            variant="contained"
            onClick={approveClick}
          >
            Approve
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReceiverSection;
